import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { Button, Spinner } from "reactstrap";
import { msalSettingsServices } from "../../services";
import * as types from "../../types";
import BigModal from "../utils/BigModal";
import MsalInput from "./PrivateMsalInput";
import "./msalsetting.css";

import { dispatch } from "../../actions/util";
import messages from "../../util/messages";

const MSALSettingModal = ({ isBigModalOpen, toggleModal, isFetching }) => {
  const { register, handleSubmit, reset, errors } = useForm();
  const onCloseModal = () => {
    toggleModal();
  };
  const updateMSALSettings = async (params) => {
    dispatch(types.FETCHING);
    msalSettingsServices()
      .updateMSALSettings(params)
      .then(() => {
        onCloseModal();
        dispatch(types.FETCHING_END);
        dispatch(types.ADD_ALERT_NOTIFICATION, {
          message: messages[types.UPDATE_MSAL_SETTINGS_GET_TITLE_SUCCESS],
          color: "info",
        });
      })
      .catch((err) => {
        dispatch(types.ADD_ALERT_NOTIFICATION, {
          message:
            err.response?.data?.message ||
            messages[types.UPDATE_MSAL_SETTINGS_FAILURE],
          color: "danger",
        });
        dispatch(types.FETCHING_END);
      });
  };

  const getMSALSettings = async () => {
    dispatch(types.FETCHING);
    msalSettingsServices()
      .getMSALSettings()
      .then((res) => {
        if (res && res.data) {
          const setting = {
            clientId: res.data.clientID ?? "",
            tenantId: res.data.tenantID ?? "",
            redirectUri: res.data.redirectUri ?? "",
            groups: res.data.groups ?? "",
          };
          reset(setting);
        }
        dispatch(types.FETCHING_END);
      })
      .catch(() => {
        const setting = {
          clientId: "",
          tenantId: "",
          redirectUri: "",
          groups: "",
        };
        reset(setting);
        dispatch(types.FETCHING_END);
      });
  };
  useEffect(() => {
    getMSALSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BigModal
      className="md-modal"
      title={"MSAL Settings"}
      isBigModalOpen={isBigModalOpen}
      toggleModalAction={onCloseModal}
    >
      <div>
        <form
          className=" "
          onSubmit={handleSubmit((values) => {
            updateMSALSettings(values);
          })}
        >
          <div>
            <MsalInput
              name="clientId"
              label="Client Id"
              register={register}
              errors={errors}
              isTypePassword={false}
            />
            <MsalInput
              name="tenantId"
              label="Tenant Id"
              register={register}
              errors={errors}
              isTypePassword={false}
            />
            <MsalInput
              name="redirectUri"
              label="Redirect Uri"
              register={register}
              errors={errors}
              isTypePassword={false}
            />
            <MsalInput
              name="groups"
              label="Groups (comma separated)"
              register={register}
              errors={errors}
              isTypePassword={false}
            />
            <div
              className="col-12"
              style={{
                marginTop: "30px",
                borderTop: "1px solid #797979",
                paddingTop: "15px",
              }}
            >
              {isFetching ? (
                <>
                  <Spinner size="sm">Loading...</Spinner>
                </>
              ) : (
                <input
                  type="submit"
                  className="btn btn-outline-secondary"
                  value="Save"
                />
              )}{" "}
              or{" "}
              <Button
                outline
                color="danger"
                onClick={() => {
                  onCloseModal();
                }}
                disabled={isFetching}
              >
                Cancel
              </Button>
            </div>
          </div>
        </form>
      </div>
    </BigModal>
  );
};
export default MSALSettingModal;
